window.initBtnCornerOutlineHover = function initBtnCornerOutlineHover() {
  const btnCornerOutlineElsArr = document.querySelectorAll('.btn-corner-outline,.btn-corner');

  if (!btnCornerOutlineElsArr.length) return;

  btnCornerOutlineElsArr.forEach((btnCornerOutlineEl) => {
    if (btnCornerOutlineEl.classList.contains('is-btn-corner-init')) return;

    btnCornerOutlineEl.classList.add('is-btn-corner-init');

    const contentWrapper = document.createElement('div');
    contentWrapper.classList.add('btn__content');

    const originalNodes = Array.from(btnCornerOutlineEl.childNodes);
    originalNodes.forEach((node) => {
      contentWrapper.appendChild(node.cloneNode(true));
    });

    btnCornerOutlineEl.appendChild(contentWrapper);
  });
};

initBtnCornerOutlineHover();